<template>
  <BDropdown
    :text="label"
    variant="outline-secondary"
    class="menu-dropdown"
    menu-class="menu-dropdown__menu"
    toggle-class="menu-dropdown__toggle"
    @show="handleShow"
  >
    <BDropdownForm class="menu">
      <CellTypeMenuContent
        :options="props.options"
        @select="selectOption"
      />
    </BDropdownForm>
  </BDropdown>
</template>

<script setup lang="ts">
import { BDropdown, BDropdownForm } from "bootstrap-vue-next";
import type { CellTypeMenuOption } from "@/utils/constants/cellTypeMenuConfig";
import CellTypeMenuContent from "./CellTypeMenuContent.vue";

const props = defineProps<{ label: string; options: CellTypeMenuOption[] }>();

const emit = defineEmits<{
  (e: "select", option: CellTypeMenuOption): void;
  (e: "open"): void;
}>();

function selectOption(option: CellTypeMenuOption) {
  emit("select", option);
}

function handleShow() {
  emit("open");
}
</script>

<style scoped>
.menu-dropdown {
  display: inline-flex;
}

.menu-dropdown__toggle {
  width: 240px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.menu-dropdown__menu {
  min-width: 520px;
  
}

</style>
